import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = axios.create({ baseURL: `${BACKEND_URL}/api` });

API.interceptors.request.use((config) => {
  const t = localStorage.getItem('skyway_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Global response handling — prevents uncaught runtime errors and gracefully
// redirects if the session has expired or the account lost required privileges.
API.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const path = typeof window !== 'undefined' ? window.location.pathname : '';

    if (status === 401) {
      try { localStorage.removeItem('skyway_token'); } catch {}
      if (path.startsWith('/admin')) {
        if (path !== '/admin') window.location.replace('/admin');
      }
    }
    if (status === 403 && path.startsWith('/admin/')) {
      // Non-admin trying to hit admin endpoints — bounce to admin login.
      try { localStorage.removeItem('skyway_token'); } catch {}
      window.location.replace('/admin');
    }
    return Promise.reject(err);
  }
);

export default API;
